import React from 'react';
import { Check, Calendar, Clock, DollarSign } from 'lucide-react';
import { useApp } from '../context/AppContext';

const ConfirmationView = () => {
  const { selectedProvider, bookingData, confirmedBooking, resetBooking, formatDate, calculateTotal } = useApp();
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-600 via-teal-500 to-emerald-500 flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl shadow-2xl max-w-lg w-full p-8 text-center">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <Check className="w-10 h-10 text-green-600" />
        </div>
        <h1 className="text-3xl font-bold text-slate-800 mb-2">Booking Confirmed!</h1>
        <p className="text-slate-500 mb-8">Your appointment has been scheduled</p>
        <div className="bg-slate-50 rounded-2xl p-6 mb-6 text-left">
          <div className="flex items-center gap-4 mb-4 pb-4 border-b">
            <img 
              src={selectedProvider?.avatarUrl || `https://ui-avatars.com/api/?name=${encodeURIComponent(selectedProvider?.name || 'Provider')}&background=0d9488&color=fff`} 
              alt="" 
              className="w-16 h-16 rounded-xl object-cover" 
            />
            <div>
              <p className="font-semibold text-slate-800">{selectedProvider?.name || `${selectedProvider?.firstName} ${selectedProvider?.lastName}`}</p>
              <p className="text-slate-500 text-sm">{selectedProvider?.providerType?.name || selectedProvider?.providerType}</p>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex items-center gap-3 text-slate-600">
              <Calendar className="w-5 h-5 text-teal-600" />
              {formatDate(bookingData.date)}
            </div>
            <div className="flex items-center gap-3 text-slate-600">
              <Clock className="w-5 h-5 text-teal-600" />
              {bookingData.time} • {bookingData.duration} hrs
            </div>
            <div className="flex items-center gap-3 text-slate-600">
              <DollarSign className="w-5 h-5 text-teal-600" />
              Paid: ${calculateTotal()}
            </div>
          </div>
        </div>
        <div className="bg-teal-50 rounded-xl p-4 mb-6 text-left text-sm">
          <p className="text-teal-800 font-medium">What's Next?</p>
          <ul className="text-teal-700 mt-2 space-y-1">
            <li>• Confirmation email sent</li>
            <li>• Provider will contact you 24 hrs before</li>
            <li>• Manage booking in "My Appointments"</li>
          </ul>
        </div>
        <button onClick={resetBooking} className="w-full py-4 bg-gradient-to-r from-teal-600 to-emerald-500 text-white rounded-xl font-semibold">
          Back to Home
        </button>
        <p className="text-slate-400 text-sm mt-4">Booking #{confirmedBooking?.bookingNumber}</p>
      </div>
    </div>
  );
};

export default ConfirmationView;
